import React from 'react';
import { FilterCollapsableWrapper } from '../../FiltersWrappers/FilterCollapsableWrapper/FilterCollapsableWrapper';
import CustomCheckSelector from './customCheckSelector/customCheckSelector';

interface CheckSelectorProps {
  filterType: string;
  noBottomDivider?: boolean;
}

export const CheckSelector = ({ filterType, noBottomDivider }: CheckSelectorProps) => {
  return (
    <>
      <FilterCollapsableWrapper
        filterType={filterType}
        noBottomDivider={noBottomDivider}
      >
        <CustomCheckSelector filterType={filterType} />
      </FilterCollapsableWrapper>
    </>
  );
};
